<template>
    <div class="view view__lms_superadmin_customer_service_sso_edit">
        <lms-superadmin-customer-service-sso-edit></lms-superadmin-customer-service-sso-edit>
        <pop-notify
            ref="popNotify"
            :class="'pop__notify--redirect'"
            @emit-submit="redirect"
        />
    </div>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import { allowRedirectBeforeRouteLeave } from '@/helpers/mixins'
import LmsSuperadminCustomerServiceSsoEdit from '@/components/lms/superadmin/customer/service/edit/LmsSuperadminCustomerServiceSSOEdit'

export default {
  name: 'view-lms-superadmin-customer-service-sso-edit',
  components: { LmsSuperadminCustomerServiceSsoEdit, PopNotify },
  mixins: [allowRedirectBeforeRouteLeave],
  computed: {
    routeCustomerId () {
      return this.$route.params.customerId
    },
    routeSubscriptionId () {
      return this.$route.params.subscriptionId
    }
  },
  methods: {
    getServiceSamlUrls (subscriptionId) {
      return this.$store.dispatch('ebsServiceSSOGetSAMLUrls', subscriptionId)
    },
    getCustomer () {
      this.$eventBus.$emit('start-loading')
      this.$store.dispatch('lmsSuperadminCustomerGet', this.routeCustomerId).then(response => {
        const subscriptionId = this.routeSubscriptionId
        const subscriptions = JSON.parse(JSON.stringify(response.subscriptions))
        const extendedSubscription = subscriptions.length ? subscriptions.find(obj => obj.id === subscriptionId) : null

        if (extendedSubscription) {
          this.$store.dispatch('ebsServiceSSOSetData', extendedSubscription)
          this.getServiceSamlUrls(subscriptionId).finally(() => {
            this.$eventBus.$emit('stop-loading')
          })
        }
      })
    }
  },
  created () {
    this.getCustomer()
  },
  mounted () {
    this.$eventBus.$on('customer-service-submit', this.allowRedirect)
  },
  beforeDestroy () {
    this.$eventBus.$off('customer-service-submit')
  }
}
</script>
